export default __webpack_public_path__ + "images/2d-workflow-icon.png";